const PrestationApi=[

  {
      id: 1,
      category: "Prestation",
      year: " Marketing digital",
      title: "STRATÉGIE & OPTIMISATION DIGITALE",
      desc: "Référencement, SEO, Audit, Marketing, Netlinking, Réseaux sociaux et Community management",
      rate: "🥇"
  },

  {
      id: 2,
      category: "Prestation",
      year: "NOS INTERLOCUTEURS ET INGÉNIEURS",
      title: "NOTRE ASSISTANCE",
      desc: "Notre équipe est disponible 24H/24, prompte à vous répondre en assistances logicielles et matérielles. ",
      rate: "👨‍💻"
  },



{
    id: 3,
    category: "Prestation",
    year: "Identité visuelle et positionnement marketing",
    title: "CRÉATION GRAPHIQUE",
    desc: "Logo, charte graphique, ergonomie, UI & UX Design, Webdesign, magazines, catalogues, covering véhicule, sérigraphie, packaging…",
    rate: "❄️",
},
{
    id: 4,
    category: "Prestation",
    year: "Optimisation et rapidité ",
    title: "RÉSEAUX INFORMATIQUES",
    desc: "Sauvegarde des données sur le cloud ou sur les serveurs, intégration d’infrastructures réseaux, sécurité, étude de couverture, système de communication",
    rate: "📡",
},
{
    id: 5,
    category: "Prestation",
    year: "En divers domaines numériques.",
    title: "INFOGÉRANCE",
    desc: "Prise en charge totale ou partielle de votre environnement informatique tout en respectant les normes.",
    rate: "⚡",
},
]
export default PrestationApi;
